export default __webpack_public_path__ + "static/media/AroundUs.83103fcd.JPG";